module.exports = __webpack_public_path__ + "img/co-carbon-m.442adc98.svg";